// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Documents_wrap__10yuS","footer":"Documents_footer__20b2v"};